define('plugins/musicfavourite/vendor',["require", "exports", "./vendor/bean", "./vendor/bonzo", "./vendor/qwery", "./vendor/pubsub-categories"], function (require, exports, bean, bonzo, qwery, pubsub) {
    "use strict";
    exports.__esModule = true;
    exports.bean = bean;
    exports.bonzo = bonzo;
    exports.qwery = qwery;
    exports.pubsub = pubsub;
});
//# sourceMappingURL=vendor.js.map;
